import * as Yup from 'yup';

export default Yup.object().shape({
  password: Yup.string()
    .length(8, 'ERRORS.PASSWORD_SHOULD_BE_8_DIGITS_LONG')
    .required('SCHEMA_ERRORS.CIEC_PASSWORD_REQUIRED')
});
